import React, { useState, useEffect } from 'react'
import { Input, Select, Flex, Button } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

function isVirtual() {
  return window?.Cypress ? false : true
}

export const EmailField = ({ onChange, onBlur, value, error }) => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Flex vertical={true} gap="small">
        <label>
          <FormattedMessage id="users.email" />:
        </label>
        <Input
          type="email"
          name="email"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          placeholder={intl.formatMessage({ id: 'users.email' })}
        />
      </Flex>
      {error && <div className="form-text-error">{error}</div>}
    </React.Fragment>
  )
}

export const RoleField = ({
  onChange,
  value,
  error,
  options,
  disabled = false,
}) => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Flex vertical={true} gap="small">
        <label>
          <FormattedMessage id="users.role" />:
        </label>
        <Select
          name="role"
          options={options}
          onChange={onChange}
          value={value == '' ? [] : value}
          placeholder={intl.formatMessage({ id: 'users.role' })}
          disabled={disabled}
          virtual={isVirtual()}
        />
      </Flex>
      {error && <div className="form-text-error">{error}</div>}
    </React.Fragment>
  )
}

export const PlantField = ({
  role,
  options,
  onChange,
  value,
  error,
  disabled = false,
}) => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Flex vertical={true} gap="small">
        <label>
          <FormattedMessage id="users.plant" />:
        </label>
        <Select
          className="select"
          name="plant"
          options={options}
          onChange={onChange}
          mode="multiple"
          value={value}
          placeholder={intl.formatMessage({ id: 'users.plant' })}
          disabled={disabled}
          virtual={isVirtual()}
        />
      </Flex>
      {error && <div className="form-text-error">{error}</div>}
    </React.Fragment>
  )
}

export const DisabledField = ({
  options,
  onChange,
  value,
  disabled = false,
}) => {
  const intl = useIntl()
  return (
    <Flex vertical={true} gap="small">
      <label>
        <FormattedMessage id="users.disabled" />:
      </label>
      <Select
        className="select"
        allowClear={false}
        name="disabled"
        options={options}
        onChange={onChange}
        value={value}
        placeholder={intl.formatMessage({ id: 'users.disabled' })}
        disabled={disabled}
        virtual={isVirtual()}
      />
    </Flex>
  )
}

export const Buttons = ({
  isSaving,
  onSubmit,
  values,
  savingDisabled = false,
}) => {
  const history = useHistory()
  const [disabled, toggleDisabled] = useState(true)

  useEffect(() => {
    if (
      values &&
      values.email?.length != 0 &&
      values.role?.length != 0 &&
      values.plant &&
      !savingDisabled
    ) {
      toggleDisabled(false)
    } else {
      toggleDisabled(true)
    }
  }, [values, savingDisabled])

  return (
    <Flex vertical={false} gap="large" justify="center">
      <Button
        type="primary"
        disabled={disabled}
        onClick={() => onSubmit(values)}
      >
        {isSaving ? (
          <FormattedMessage id="processes.saving" />
        ) : (
          <FormattedMessage id="forms.save" />
        )}
      </Button>
      <Button
        type="default"
        onClick={() => history.push(`/users`)}
        disabled={isSaving}
        className="user-form-cancel"
      >
        <FormattedMessage id="forms.cancel" />
      </Button>
    </Flex>
  )
}

export const FeatureFlagField = ({
  options,
  onChange,
  value,
  error,
  disabled = false,
  hidden = false,
}) => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Flex vertical={true} gap="small" className={hidden ? 'hide' : ''}>
        <label>
          <FormattedMessage id="users.featureFlag" />:
        </label>
        <Select
          className="select"
          name="feature_flag"
          options={options}
          onChange={onChange}
          mode="multiple"
          value={value}
          placeholder={intl.formatMessage({ id: 'users.featureFlag' })}
          disabled={disabled}
          hidden={hidden}
          virtual={isVirtual()}
        />
      </Flex>
      {error && <div className="form-text-error">{error}</div>}
    </React.Fragment>
  )
}

export const OrganisationTypeField = ({
  onChange,
  value,
  error,
  options,
  disabled = false,
  hidden = false,
}) => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Flex vertical={true} gap="small" className={hidden ? 'hide' : ''}>
        <label>
          <FormattedMessage id="users.organisationType" />:
        </label>
        <Select
          className="select"
          name="organisation_type"
          options={options}
          onChange={onChange}
          value={value}
          placeholder={intl.formatMessage({ id: 'users.organisationType' })}
          disabled={disabled}
          hidden={hidden}
          allowClear
          virtual={isVirtual()}
        />
      </Flex>
      {error && <div className="form-text-error">{error}</div>}
    </React.Fragment>
  )
}

export const MakeField = ({
  options,
  onChange,
  value,
  error,
  disabled = false,
  hidden = false,
}) => {
  const intl = useIntl()
  return (
    <React.Fragment>
      <Flex vertical={true} gap="small" className={hidden ? 'hide' : ''}>
        <label>
          <FormattedMessage id="users.make" />:
        </label>
        <Select
          className="select"
          name="make"
          options={options}
          onChange={onChange}
          mode="multiple"
          value={value}
          placeholder={intl.formatMessage({ id: 'users.make' })}
          disabled={disabled}
          hidden={hidden}
          virtual={isVirtual()}
        />
      </Flex>
      {error && <div className="form-text-error">{error}</div>}
    </React.Fragment>
  )
}
